import React from 'react';
import { Grid, Avatar, Typography } from '@material-ui/core';
import { PersonModel } from '../../models/personModel';
import { getFullName } from '../../utils/personUtils';
import { usePersonInfoStyles } from './style';

interface Props {
  official?: PersonModel;
}

export function OfficialAvatarAndName(props: Props) {
  const { official } = props;
  const styles = usePersonInfoStyles();
  return (
    <Grid container item direction='column' className={styles.container}>
      <Grid item>
        <Avatar alt='P' src={official?.avatarUrl} className={styles.avatar} variant='rounded' />
      </Grid>
      <Grid item>
        <Typography variant='h5' className={styles.fullName}>
          {getFullName(official?.preferredGivenName, official?.preferredFamilyName)}
        </Typography>
      </Grid>
    </Grid>
  );
}
